import React from "react";
import { connect } from "react-redux";
import TextBox from 'devextreme-react/text-box';
import DateBox from "devextreme-react/date-box";
import { SelectBox } from 'devextreme-react/select-box';
import ValidationSummary from 'devextreme-react/validation-summary';
import { GridLayout } from "../../../../common/GridLayout";
import { GetDatePartOnlyDiffFormat } from "../../../../common/Utils";
import { Button } from 'devextreme-react/button';
import InspectionDetailsApi from "../../transactions/inspection/InspectionDetailsApi";
import DataSource from "devextreme/data/data_source";
import ArrayStore from 'devextreme/data/array_store';
import { LoadPanel } from 'devextreme-react/load-panel';
import { Localization } from "../../../../common/Localization";
import {
    Validator,
    RequiredRule,
    StringLengthRule
} from 'devextreme-react/validator';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";

import DataGrid, {
    Column,
    Paging,
    FilterRow,
    FilterPanel,
    ColumnChooser,
    ColumnChooserSearch,
    FilterBuilderPopup,
    StateStoring,
    Editing,
    Export,
    Pager,
    HeaderFilter,
    Selection,
    Sorting,
    Toolbar,
    Lookup,
    Item
} from 'devextreme-react/data-grid';
import notify from "devextreme/ui/notify";

const filterBuilderPopupPosition = {
    of: window,
    at: "top",
    my: "top",
    offset: { y: 10 },
};
let accessToken = '';
const gridKey = "fd2baf76-033c-4833-89c2-9700c175a8b1";
const dataGrid = React.createRef();

let inspectionTypeSelectBox = React.createRef();
class InspectionDetailTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inspectionrowid: "",
            inspectionid: "",
            supervisor: "",
            loadIndicatorVisible: false,
            inspectiondate: new Date(),
            inspectiontype: "",
            disableSaveButton: false,
            assetArr: [],
            selectedItemKeys: [],
            rametcoderowid: "",
            currentLayout: "Default",
        };
        accessToken = props.oidc.user.access_token;
        this.InspectionDetailsApi = new InspectionDetailsApi(props.oidc.user.access_token);
        this.LoadInspectionTypes = this.LoadInspectionTypes.bind(this);
        this.LoadGrid = this.LoadGrid.bind(this);
        this.SaveRecord = this.SaveRecord.bind(this);
        this.isValidDate = this.isValidDate.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.InsertDetailsChanges = this.InsertDetailsChanges.bind(this);
    }
    setCurrentLayout =(value)=>{
        this.setState({
          currentLayout:value
        })
      }
      loadState = () => {return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null, this.state.currentLayout);}
      saveState=(state)=> { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, this.state.currentLayout);}    
    componentDidMount() {
        this.LoadInspectionTypes();
    }
    LoadInspectionTypes = async () => {
        try {
            this.setState({ loadIndicatorVisible: true });
            var _api = this.InspectionDetailsApi.getInspectionId();
            var _api2 = this.InspectionDetailsApi.loadInspectionTypes();
            const [inspectionIdRes, inspectionTypeDataSource] = await Promise.all([
                _api, _api2
            ]);
            if (inspectionTypeDataSource.data.success) {
                let InspectionTypeDataStore = new DataSource({
                    store: new ArrayStore({
                        data: inspectionTypeDataSource.data.resultdata
                    }),
                    paginate: true,
                    pageSize: 100
                });
                inspectionTypeSelectBox.current.instance().option(
                    "dataSource",
                    InspectionTypeDataStore
                );
                inspectionTypeSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            }
            if (inspectionIdRes.data.success)
                this.setState({ inspectionid: inspectionIdRes.data.resultdata });
            this.setState({ loadIndicatorVisible: false });
        } catch (e) {
            console.log(e, "Error in loading inspection type codes.");
            this.setState({ loadIndicatorVisible: false });
        }
    }
    LoadGrid = async () => {
        try {
            this.setState({ loadIndicatorVisible: true });
            const result = await this.InspectionDetailsApi.loadInspectionRametCodes();
            if (result.status == 200) {
                this.setState({
                    assetArr: result.data.data,
                    selectedItemKeys: []
                });
            }
            else {
                this.setState({
                    assetArr: [],
                    selectedItemKeys: []
                });
            }

            const response = await this.InspectionDetailsApi.loadSavedInspectionDetail(this.state.inspectionrowid);
            if (response.data.success) {
                this.setState({
                    selectedItemKeys: response.data.resultdata.map(v => (v.assetid))
                });
            }
            else {
                this.setState({
                    selectedItemKeys: []
                });
                notify({
                    message: response.data.message,
                    width: 100,
                }, 'error', 2000);
            }
            this.setState({ loadIndicatorVisible: false });
        } catch (error) {
            this.setState({ loadIndicatorVisible: false });
        }
    }
    SaveRecord = async (e) => {
        try {
            this.setState({ loadIndicatorVisible: true });
            e.preventDefault();
            var rqst = this.state;
            if (this.isValidDate(rqst.inspectiondate))
                rqst.inspectiondate = GetDatePartOnlyDiffFormat(rqst.inspectiondate, "/");
            else {
                notify({
                    message: 'Please enter valid date.',
                    width: 100,
                }, 'error', 2000);
                this.setState({ loadIndicatorVisible: false });
                return;
            }
            const result = await this.InspectionDetailsApi.saveInspectionHeader(rqst);
            if (result.data.success) {
                this.setState({
                    inspectionrowid: result.data.resultdata.inspectionrowid,
                    disableSaveButton: true,
                });
                notify({
                    message: 'Sucessfully Saved!',
                    width: 100,
                }, 'success', 2000);
            }
            else {
                this.setState({
                    inspectionrowid: "",
                    disableSaveButton: false
                });
                notify({
                    message: result.data.message,
                    width: 100,
                }, 'error', 2000);
            }
            this.setState({ loadIndicatorVisible: false });
            this.LoadGrid();
        } catch (error) {
            this.setState({ loadIndicatorVisible: false });
        }
    }
    isValidDate(date) {
        return date && !isNaN(Date.parse(date));
    }
    onSelectionChanged(e) {
        const currentSelectedRowKeys = e.currentSelectedRowKeys;
        const currentDeselectedRowKeys = e.currentDeselectedRowKeys;
        this.InsertDetailsChanges(currentSelectedRowKeys, currentDeselectedRowKeys);
    }
    InsertDetailsChanges = async (currentSelectedRowKeys, currentDeselectedRowKeys) => {
        try {
            this.setState({ loadIndicatorVisible: true });
            if (currentSelectedRowKeys.length > 0) {
                const result = await this.InspectionDetailsApi.saveInspectionAssetDetail({ inspectionrowid: this.state.inspectionrowid, Assetidarr: currentSelectedRowKeys });
                if (result.data.success) {
                    this.setState({
                        selectedItemKeys: result.data.resultdata.map(v => (v.assetid))
                    });
                }
                else {
                    notify({
                        message: result.data.message,
                        width: 100,
                    }, 'error', 2000);
                }
            }
            if (currentDeselectedRowKeys.length > 0) {
                const result = await this.InspectionDetailsApi.deleteInspectionDetail({ inspectionrowid: this.state.inspectionrowid, assetid: currentDeselectedRowKeys[0] });
                if (result.data.success) {
                    this.setState({
                        selectedItemKeys: result.data.resultdata.map(v => (v.assetid))
                    });
                }
                else {
                    notify({
                        message: result.data.message,
                        width: 100,
                    }, 'error', 2000);
                }
            }
            this.setState({ loadIndicatorVisible: false });
        } catch (error) {
            this.setState({ loadIndicatorVisible: false });
        }
    }
    render() {
        return (
            <div style={{ overflowY: 'hidden' }}>
                <div className="row bg-white p-3">
                    <LoadPanel
                        shadingColor="rgba(0,0,0,0.4)"
                        visible={this.state.loadIndicatorVisible}
                        showIndicator={true}
                        shading={true}
                        showPane={true}
                        hideOnOutsideClick={false}
                    />
                    <form onSubmit={(e) => this.SaveRecord(e)}>
                        <div className="row">
                            <div className="col-md-2">
                                <label htmlFor="inspection-details-id" className="field-label">
                                    Inspection ID
                                </label>
                                <TextBox
                                    name="inspection-details-id"
                                    className="input-field"
                                    type="text"
                                    placeholder=""
                                    value={this.state.inspectionid}
                                    disabled={true}
                                    onValueChanged={(data) => this.setState({ inspectionid: data.value })}>
                                    <Validator>
                                        <RequiredRule message="Inspection ID is required." />
                                        <StringLengthRule message="Inspection ID can have maximum 20 characters" max={20} />
                                    </Validator>
                                </TextBox>
                            </div>
                            <div className="col-md-2">
                                <label htmlFor="inspection-details-supervisor" className="field-label">
                                    Supervisor
                                </label>
                                <TextBox
                                    name="inspection-details-supervisor"
                                    className="input-field"
                                    type="text"
                                    placeholder=""
                                    value={this.state.supervisor}
                                    onValueChanged={(data) => this.setState({ supervisor: data.value })}>
                                    <Validator>
                                        <RequiredRule message="Inspection supervisor is required." />
                                        <StringLengthRule message="Inspection supervisor can have maximum 50 characters" max={50} />
                                    </Validator>
                                </TextBox>
                            </div>
                            <div className="col-md-2">
                                <label htmlFor="inspection-details-date" className="field-label">
                                    Date
                                </label>
                                <DateBox
                                    type="date"
                                    placeholder=""
                                    value={this.state.inspectiondate}
                                    name="inspection-details-date"
                                    displayFormat="shortdate"
                                    onValueChanged={(data) => this.setState({ inspectiondate: data.value })}
                                />
                            </div>
                            <div className="col-md-2">
                                <label htmlFor="inspection-type" className="field-label">
                                    Inspection Type
                                </label>
                                <SelectBox
                                    ref={inspectionTypeSelectBox}
                                    searchEnabled={true}
                                    placeholder="Inspection Type"
                                    onValueChanged={(data) => this.setState({ inspectiontype: data.value })}
                                    displayExpr="name"
                                    valueExpr="id"
                                    name="inspection-type"
                                    className="w-100"
                                    value={this.state.inspectiontype}
                                    acceptCustomValue={true} />
                            </div>
                            <div className="col-md-2 " style={{paddingTop:'34px'}}>
                                <Button
                                    text="Save"
                                    type="default"
                                    disabled={this.state.disableSaveButton}
                                    useSubmitBehavior={true}
                                    stylingMode="contained">
                                </Button>
                            </div>
                            <div className="col-md-2">
                                <ValidationSummary id="summary" />
                            </div>
                        </div>
                    </form>
                </div>
                <div className="row accordianLastRow" style={{ paddingBottom: '10px' }}>
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                              ref={dataGrid}
                        dataSource={this.state.assetArr}
                        showBorders={true}
                        className="ReportFilterPanelHeightAccordionClose"
                        hoverStateEnabled={true}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        rowAlternationEnabled={true}
                        columnAutoWidth={true}
                        keyExpr={"rowid"}
                        onSelectionChanged={(e) => this.onSelectionChanged(e)}
                        showRowLines={true}
                        remoteOperations={true}
                        showColumnLines={false}>
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={900}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <Sorting mode="multiple" />
                        <LoadPanel enabled={true} />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <HeaderFilter visible={true} />
                        <FilterBuilderPopup position={filterBuilderPopupPosition} />
                        <Export enabled={true} allowExportSelectedData={true} text="Export" />
                        <Selection mode="multiple" allowSelectAll={true} />
                        <Paging defaultPageSize={10} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                            showNavigationButtons={true}
                        />
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={this.loadState}
                            storageKey={gridKey}
                            customSave={this.saveState}
                        />
                        <Editing
                            mode="row"
                            useIcons={true}
                            allowUpdating={false}
                            allowDeleting={false} />
                        <Column dataField="posx" caption="Row"></Column>
                        <Column dataField="posy" caption="Col"></Column>
                        <Column dataField="code" caption="Code"></Column>
                        <Column dataField="parent" caption="Parent"></Column>
                        <Column dataField="orchardcode" caption="Orchard"></Column>
                        <Column dataField="blockcode" caption="Block"></Column>
                        <Column dataField="locationcode" caption="Location"></Column>
                        <Column dataField="description" caption="Description" visible={false}></Column>
                        <Column dataField="orchardtype" caption="Orchard Type" visible={false}></Column>
                        <Column dataField="elevation" caption="Elevation" visible={false}></Column>
                        <Column dataField="species" caption="Species" visible={false}></Column>
                        <Column dataField="blockcycle" caption="Block Cycle" visible={false}></Column>
                        <Column dataField="stimcycle" caption="Stim Cycle" visible={false}></Column>
                        <Column dataField="stimstatus" caption="Stim Status" visible={false}></Column>
                        <Column dataField="userstatus" caption="Ramet Status" >
            <Lookup
              dataSource={this.userStatusDataSource}
              displayExpr="description1"
              valueExpr="code" />
          </Column>
                        <Column dataField="breedingarea" caption="Breeding Area" visible={false}></Column>
                        <Column dataField="rootstock" caption="Root Stock"></Column>
                        <Column dataField="graftdate" dataType="date" caption="Graft Date"></Column>
                        <Column dataField="plantdate" dataType="date" caption="Plant Date"></Column>
                        <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={this.setCurrentLayout} />
                 </Item>
                    </DataGrid>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(InspectionDetailTabs);